import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';

export default function MetaTags({ canonical }) {
  const { t } = useTranslation();
  return (
    <Helmet>
      <title>
        {t('Vialaser loja online | Ecommerce de depilação a laser')}
      </title>
      <meta
        name="description"
        content={t(
          'Compre depilação a laser na loja online da Vialaser Um jeito ainda mais fácil de adquirir o seu melhor pacote de depilação com o melhor preço',
        )}
      />
      <meta
        name="keywords"
        content={t(
          'depilação a laser, comprar depilação a laser, depilação a laser preço',
        )}
      />
      <link rel="canonical" href={canonical} />
    </Helmet>
  );
}
